/**
 * foundryPerth.js — content module for /foundry/perth spoke page.
 * DRAFT — PENDING SAKIB REVIEW
 * Synthesised from 03-offers.md + _seo/00-seo-plan.md Cluster A (Perth local)
 */

export const foundryPerthHead = {
  eyebrow: 'The Foundry \u00b7 Perth',
  heading: 'The Foundry, Perth',
  subheading: 'Face-to-face AI cohort for Perth founders.',
};

/** @DRAFT — Sakib must review before production */
export const foundryPerthIntro =
  'The same six-week Foundry cohort, run face-to-face in Perth, Western Australia. Five founders per run. You build production-grade AI systems into your business alongside four other Perth-area founders, with in-person sessions, hands-on guidance, and the advantage of being in the same room.';

/** @DRAFT */
export const foundryPerthWhy = {
  heading: 'Why Perth, face-to-face',
  paragraphs: [
    'Some problems solve faster when you are in the same room. The Foundry Perth runs the same curriculum, the same build-alongside-us format, and the same Founders Table membership as the global cohort. The difference is proximity: same-day whiteboard sessions, real-time pair building, and a local peer network of founders building AI into Perth and Western Australian businesses.',
    'If your business operates in Perth or regional WA, this is the cohort built for your timezone, your market, and your operational context. AUD pricing for Australian seats.',
  ],
};

/** @DRAFT */
export const foundryPerthFormat = {
  heading: 'Format',
  items: [
    'Six weeks, face-to-face in Perth WA',
    'Five founders per cohort',
    'Weekly in-person sessions plus async support',
    'Same curriculum and outcomes as the global Foundry',
    'Founders Table membership on graduation',
  ],
};

export const foundryPerthCta = {
  label: 'Request a Foundry seat (Perth)',
};

export const foundryPerthLinks = {
  foundryGlobal: { href: '/foundry', label: 'Also available online for global seats' },
  automatedSystems: { href: '/automated-systems', label: 'Want us to build it for you instead?' },
};
